export const NAV_LINKS = [
  { name: 'Services', href: '/services' },
  { name: 'Our clients', href: '/projects' },
  { name: 'Tech stack', href: '/tech-stack' },
  { name: 'Reviews', href: '/testimonials' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contact', href: '/contact' },
];

export const SERVICES = [
  {
    id: 1,
    title: 'Custom Web Development',
    description: 'Slow or outdated site losing you customers? We build fast websites that turn visitors into enquiries.',
    icon: 'Globe',
    gradient: 'from-gray-700 to-gray-600',
    link: '/services/custom-web-development-company',
  },
  {
    id: 2,
    title: 'AI Automation Services',
    description: 'Team stuck on repetitive work? We automate it with AI, so it runs on its own around the clock.',
    icon: 'Smartphone',
    gradient: 'from-gray-600 to-gray-500',
    link: '/services/ai-automation-services',
  },
  {
    id: 3,
    title: 'Mobile App Development',
    description: 'Customers want an app? We ship one for iOS and Android from a single codebase.',
    icon: 'Smartphone',
    gradient: 'from-gray-500 to-gray-700',
    link: '/services/mobile-app-development-company',
  },
  {
    id: 4,
    title: 'Custom Software Development',
    description: 'Running the business on spreadsheets? We build software shaped around how you actually work.',
    icon: 'Building2',
    gradient: 'from-gray-700 to-gray-600',
    link: '/services/custom-software-development',
  },
  {
    id: 5,
    title: 'SaaS Platform Engineering',
    description: 'Have a product idea? We take it from MVP to a paid SaaS that scales.',
    icon: 'Cloud',
    gradient: 'from-gray-600 to-gray-500',
    link: '/services/saas-development-company',
  }
];

export const PROCESS = [
  {
    step: '01',
    title: 'Diagnose',
    description: 'We find the real problem and agree a plan, price and timeline.'
  },
  {
    step: '02',
    title: 'Design',
    description: 'You see and approve the screens before any code is written.'
  },
  {
    step: '03',
    title: 'Build',
    description: 'We build in short sprints with a demo you can try every week.'
  },
  {
    step: '04',
    title: 'Launch & support',
    description: 'We launch, monitor and keep improving it after go-live.'
  }
];

export const FAQ = [
  {
    question: 'Why work with a Gujarat-based team?',
    answer: 'You get international-quality design and engineering at Indian rates, with one team from plan to launch.'
  },
  {
    question: 'How can AI Automation help my business grow?',
    answer: 'It takes over repetitive work like replies, data entry and follow-ups, around the clock, so your team can focus on customers.'
  },
  {
    question: 'Do you offer SEO-optimized development out of the box?',
    answer: 'Yes. Every site ships with technical SEO and fast load times built in, so Google can find you from day one.'
  },
  {
    question: 'How long does a custom software project typically take?',
    answer: 'A website or MVP usually takes 4 to 8 weeks. Larger platforms take 3 to 6 months, with working demos along the way.'
  }
];

export const WHY_CHOOSE_US = [
  {
    title: 'Built to hold up',
    description: 'Fast under real traffic, not just in the demo.'
  },
  {
    title: 'AI where it saves time',
    description: 'We automate the work that eats your hours.'
  },
  {
    title: 'Measured in results',
    description: 'More enquiries and sales, not just a nicer look.'
  }
];

export const PROJECTS = [
  {
    id: 8,
    title: "Mishkat International",
    description: "A bold product showcase for a Bahrain masking-tape manufacturer exporting to 40+ markets.",
    tags: [
      "Product Catalog",
      "WhatsApp Enquiry",
      "SEO"
    ],
    color: "from-red-600 to-neutral-900",
    image: "/mockups/mishkat-cut.webp",
    mockup: true,
    type: "web",
    liveUrl: "https://www.mishkatinternational.com/",
    features: [
      "Eight tape series with clear product pages",
      "Enquire on WhatsApp from every product",
      "Quick enquiry form for distributors and OEM orders",
      "Fast, mobile-first pages for export buyers"
    ]
  },
  {
    id: 1,
    title: "Super Tech International",
    description: "A high-performance B2B procurement & digital product catalog engineered for Kuwait's premier HVAC and industrial hardware supplier in Shuwaikh.",
    tags: [
      "React",
      "Next.js",
      "TailwindCSS",
      "B2B Catalog"
    ],
    color: "from-blue-600 to-indigo-700",
    image: "/mockups/supertech-mockup.webp",
    mockup: true,
    type: "web",
    liveUrl: "https://supertechint.com.kw/",
    features: [
      "Bilingual Arabic & English dynamic product catalog architecture",
      "Instant Quote Basket with direct WhatsApp RFQ procurement pipeline",
      "Multi-category filtering across HVAC, MEP, tools, and construction supplies",
      "Ultra-fast search engine indexing 1000+ certified hardware products",
      "High-conversion mobile-first responsive UI with Core Web Vitals optimization"
    ]
  },
  {
    id: 7,
    title: "AABEX",
    description: "A B2B catalog for an electrical, switchgear, fasteners and tools supplier serving contractors and traders across the UAE.",
    tags: [
      "WordPress",
      "B2B Catalog",
      "Quote Basket"
    ],
    color: "from-orange-500 to-blue-800",
    image: "/mockups/aabex-mockup.webp",
    mockup: true,
    type: "web",
    liveUrl: "https://aabex.ae/",
    features: [
      "Product categories for electrical, switchgear, fasteners and tools",
      "Quote basket with Request a Quote for bulk orders",
      "WhatsApp chat for quick enquiries",
      "Mobile-first layout for buyers on site"
    ]
  },
  {
    id: 4,
    title: "The Travel Mart Website",
    description: "A premium, high-conversion travel booking engine engineered with real-time API integrations.",
    tags: [
      "React",
      "Next.js",
      "Stripe"
    ],
    color: "from-gray-600 to-gray-700",
    image: "/mockups/travelmart-mockup.webp",
    mockup: true,
    type: "web",
    features: [
      "Instant PCI-compliant Stripe payment gateway orchestration",
      "Dynamic real-time inventory availability verification",
      "Advanced multi-tier destination filtering and search parameters",
      "Intuitive, mobile-responsive itinerary mapping",
      "Comprehensive dashboard with instant e-ticketing and invoices"
    ]
  },
  {
    id: 2,
    title: "Sabta Trading Co. LLC",
    description: "A modern, high-speed digital catalog & RFQ dispatch platform engineered for Dubai's premier fastener and marine rigging hardware distributor since 1994.",
    tags: [
      "React",
      "Next.js",
      "TailwindCSS",
      "B2B Platform"
    ],
    color: "from-emerald-600 to-teal-700",
    image: "/mockups/sabta-cut.webp",
    mockup: true,
    type: "web",
    liveUrl: "https://sabtadxb.com/",
    features: [
      "Extensive 16,000+ item catalog spanning 304/316 marine-grade stainless & alloy hardware",
      "Integrated Quote Cart system with instant multi-item RFQ and WhatsApp dispatch",
      "Categorized hierarchy for Hose Clips, Rigging, Lifting Hardware, Circlips & Fasteners",
      "Lightning-fast multi-attribute search and real-time category filtering",
      "Enterprise SEO architecture, structured Schema JSON-LD & sub-second Core Web Vitals"
    ]
  },
  {
    id: 3,
    title: "Mumineen Dua App",
    description: "An enterprise-scale religious application successfully serving 10+ active users globally.",
    tags: [
      "Flutter",
      "Firebase",
      "Node.js"
    ],
    color: "from-gray-500 to-gray-600",
    image: "/mumineen_dua.webp",
    type: "mobile",
    features: [
      "High-fidelity interactive Dua and Prayer audio player",
      "Localized precise prayer alerts and Qibla calculations",
      "Seamless offline database synchronization capabilities",
      "Dynamic digital Tasbeeh and community counter system",
      "Multilingual script views with native character sets"
    ]
  }
];

export const STATS = [
  { value: 20, suffix: '+', label: 'Projects delivered' },
  { value: 95, suffix: '+', label: 'Performance score' },
  { value: 100, suffix: '%', label: 'Fast delivery' },
  { value: 10, suffix: '+', label: 'AI-powered solutions' },
];

export const TECH_STACK = [
  { name: 'React', icon: '⚛️', color: '#61DAFB' },
  { name: 'Flutter', icon: '💙', color: '#02569B' },
  { name: 'Firebase', icon: '🔥', color: '#FFCA28' },
  { name: 'MongoDB', icon: '🍃', color: '#47A248' },
  { name: 'MySQL', icon: '🐬', color: '#4479A1' },
  { name: 'Python', icon: '🐍', color: '#3776AB' },
  { name: 'Node.js', icon: '🟢', color: '#339933' },
  { name: 'TypeScript', icon: '🔷', color: '#3178C6' },
  { name: 'Docker', icon: '🐳', color: '#2496ED' },
  { name: 'AWS', icon: '☁️', color: '#FF9900' },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Mohammed V',
    role: 'Owner, The Mumineen App',
    projectId: 3,
    content: 'Farwings transformed our vision into reality. The Dua app they built has been downloaded by thousands and has become an essential part of our community.',
    avatar: 'MV',
  },
  {
    id: 2,
    name: 'Murtaza Khambhati',
    role: 'CEO, The Travel Mart',
    projectId: 4,
    content: 'Working with Farwings was an absolute pleasure. Their attention to detail and technical expertise resulted in a platform that exceeded our expectations.',
    avatar: 'MK',
  },
  {
    id: 3,
    name: 'Ali Asgar',
    role: 'Owner, Sabta Trading Co. LLC',
    projectId: 2,
    rating: 5,
    content: 'We had a great experience working with Farwings Tech Solutions for developing our shop’s website. Farwings is professional, supportive, and attentive to our requirements. They understood our needs and created a website that reflects our business in a professional manner. We appreciate their dedication, communication, and efforts throughout the process. Highly recommended to anyone looking for reliable website development services! Thank you, Farwings Tech Solutions, for your excellent work and support.',
    avatar: 'AA',
  },
  {
    id: 4,
    name: 'Ali Akbar Godhrawala',
    role: 'Owner, Super Tech International',
    projectId: 1,
    content: 'Farwings built us a bilingual product catalog where buyers can get a quote on WhatsApp in one tap. Our customers find what they need faster, and we spend far less time answering price calls.',
    avatar: 'AG',
  },
];

export const SOCIAL_LINKS = [
  { name: 'GitHub', href: '#', icon: 'Github' },
  { name: 'LinkedIn', href: '#', icon: 'Linkedin' },
  { name: 'Twitter', href: '#', icon: 'Twitter' },
  { name: 'Instagram', href: 'https://www.instagram.com/farwingstech', icon: 'Instagram' },
];

export const STACK_GROUPS = [
  { name: 'Web', items: ['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Vite'] },
  { name: 'Mobile', items: ['Flutter', 'React Native', 'Expo', 'Firebase'] },
  { name: 'Backend and data', items: ['Node.js', 'Express', 'Python', 'Django', 'PostgreSQL', 'MongoDB', 'MySQL'] },
  { name: 'AI and automation', items: ['OpenAI API', 'LangChain', 'Pinecone', 'Make'] },
  { name: 'Cloud', items: ['AWS', 'Docker', 'Vercel', 'Stripe'] },
];

export const CONTACT = {
  phones: ['+91 70430 31553', '+91 88668 23010'],
  whatsapp: 'https://wa.me/917043031553',
  email: 'farwingsolutions@gmail.com',
};

